import React from 'react';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-4 md:py-5 px-4 text-center" data-id="element-408">
      <div className="max-w-4xl mx-auto" data-id="element-409">
        <span className="inline-block bg-blue-100 text-blue-800 text-sm font-bold px-3 py-1 rounded-full mb-1 uppercase tracking-wide" data-id="element-410">
          La Solución
        </span>

        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-3" data-id="element-411">
          ✅ CON ESTE KIT VAS A PODER:
        </h2>

        <div className="space-y-2 text-left max-w-3xl mx-auto" data-id="element-412">
          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-413">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-414">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-415" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-416">
              Dar clases de educación financiera con material 100% argentino y
              actualizado
            </span>
          </div>

          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-417">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-418">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-419" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-420">
              Tener actividades y evaluaciones listas sin preparar nada
              adicional
            </span>
          </div>

          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-421">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-422">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-423" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-424">
              Cumplir con los NAP 2026 y justificar ante directivos con rúbricas
              por capacidades
            </span>
          </div>

          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-425">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-426">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-427" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-428">
              Conectar con tus alumnos usando ejemplos reales: el dólar, el
              CEDEARs, las estafas de WhatsApp
            </span>
          </div>

          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-429">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-430">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-431" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-432">
              Ahorrar horas de trabajo cada semana
            </span>
          </div>
        </div>
      </div>
    </section>;
}